import {
  isFavorite,
  addFavoriteItem,
  removeFavoriteItem,
} from "@src/utils/favorite";
import { getEcommerceByIds, viewItemEvent } from "@src/analytics";
import "./index.css";

export function setupShowcase() {
  const container = document.querySelector(".container-showcase");

  if (container == null) {
    return;
  }

  const propertyId: string | null = container.getAttribute("data-property-id");

  if (propertyId) {
    // GTM push `view_item` event
    getEcommerceByIds([propertyId]).then((ecommerce) => {
      viewItemEvent(ecommerce);
    });

    // set favorite
    container.setAttribute("data-favorite", isFavorite(propertyId).toString());

    // toggle favorite
    container.addEventListener("click", (event) => {
      if (event.target instanceof HTMLElement) {
        if (
          event.target.closest(".container-showcase-favorite") ||
          event.target.closest(
            ".container-showcase-gallery-toolbar-button[data-type='favorite']"
          )
        ) {
          event.stopPropagation();

          if (container.getAttribute("data-favorite") === "true") {
            // remove from favorite
            container.setAttribute("data-favorite", "false");
            removeFavoriteItem(propertyId);
          } else {
            // add to favorite
            container.setAttribute("data-favorite", "true");
            addFavoriteItem(propertyId);
          }
        }
      }
    });
  }
}
